const register = {
  loginCredentials: "אישורי כניסה", // translated
  companyInformation: "מידע על החברה", // translated
  contactDetails: "פרטי יצירת קשר", // translated
  businessName: "שם עסק", // translated
  businessAddress: "כתובת עסקית", // translated
  registrationCode: "קוד הרשמה", // translated
  websiteUrl: "כתובת אתר", // translated
  mobilePhone: "טלפון נייד", // translated
  regionStateProvince: "אזור/מדינה/מחוז", // translated
  legalTitle: "כותרת משפטית", // translated
  city: "עִיר", // translated
  postalCode: "מיקוד", // translated
  registrationSuccess: "הרשמה מוצלחת.", // translated
  pleaseWaitFewMomentsAndYouWillBeRedirectedToHome: "אנא המתן מספר רגעים ותועבר לדף הבית.", // translated
};

export default register;
